import type {
  Lead_Agent_Source_Enum_Enum,
  Lead_Agents_Updates,
} from '@graphql/__generated__/graphql';

type ResultPageReassignmentParams = {
  leadId: string;
  replacementBrokerId: string;
  replacementTeamIds: string[];
};

export const createResultPageReassignment = ({
  leadId,
  replacementBrokerId,
  replacementTeamIds,
}: ResultPageReassignmentParams): Lead_Agents_Updates => ({
  where: {
    lead_id: { _eq: leadId },
    user: {
      teams_users: {
        team_id: { _in: replacementTeamIds },
        team: {
          teams_users: {
            deactivated: { _eq: false },
            user_id: { _eq: replacementBrokerId },
          },
        },
      },
      id: { _neq: replacementBrokerId },
    },
    source: { _eq: 'result_page' as Lead_Agent_Source_Enum_Enum },
    passed_at: { _is_null: true },
  },
  _set: { passed_at: 'now()' },
});
